import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import { LoadingIcon } from "@shared/Loading";
import { Tooltip } from "@shared/Tooltip";

import { useStyles } from "./EventChartCard.styles";
import { chartHeight } from "./EventChartCard.utils";

export const EventChartCardLoading = () => {
    const { classes } = useStyles();
    const { t } = useTranslation("pages");

    return (
        <Box className={classes.chartContainer}>
            <Box className={classes.chartLoading} height={chartHeight}>
                <Tooltip title={t("overviewPage.tooltips.loadingMoreData")}>
                    <LoadingIcon size="block" />
                </Tooltip>
            </Box>
        </Box>
    );
};
